module.exports = __webpack_public_path__ + "img/novel.570b5ec0.svg";